// import Alpine from 'alpinejs';
// import { Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm';

function setViewport() {
    document.documentElement.style.setProperty( "--app-height", `${ window.innerHeight }px` );
    document.documentElement.style.setProperty( "--app-width", `${ window.innerWidth }px` );

}
function watchViewport() {
    window.addEventListener( "resize", Alpine.debounce( setViewport, 100 ) );
    setViewport();
}

export { watchViewport };
